module.exports = __webpack_public_path__ + "static/media/intro.ba33a3e3.mp3";